import { Base } from "../core/base.model";


export class EvidenciaBean extends Base{
    id: number;
    nombre: string;
    idDetalle: number;
    
    	
	idProyecto:number;
    idIncidencia:number;
    idTarea:number;

}